(function () {
  const scenes = document.querySelectorAll('[data-action-cinema]');
  if (!scenes.length) return;
  if (window.gsap && window.ScrollTrigger) {
    window.gsap.registerPlugin(window.ScrollTrigger);
  }
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const presets = {
    elegant: { fg: 70, bg: 22, zoom: .18, product: .3, light: 46 },
    cinematic: { fg: 118, bg: 38, zoom: .32, product: .42, light: 70 },
    high: { fg: 168, bg: 54, zoom: .46, product: .55, light: 94 }
  };
  const clamp = (n, min, max) => Math.min(Math.max(n, min), max);
  const ease = n => 1 - Math.pow(1 - clamp(n, 0, 1), 3);
  function setDots(scene, p) {
    const dots = scene.querySelectorAll('[data-dot]');
    const active = clamp(Math.floor(p * dots.length), 0, dots.length - 1);
    dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
  }
  function setSignals(scene, p) {
    const nodes = scene.querySelectorAll('.signal');
    nodes.forEach((node, i) => {
      const local = ease((p - (.34 + i * .038)) / .18);
      const orbit = Math.sin((p * Math.PI * 1.3) + i) * 10;
      node.style.opacity = `${local}`;
      node.style.transform = `translate3d(${orbit}px, ${26 - local * 34}px, 0) scale(${.92 + local * .08})`;
      node.style.boxShadow = `0 ${10 + local * 12}px ${30 + local * 32}px rgba(8,37,28,${.08 + local * .08})`;
    });
  }
  function render(scene) {
    const intensity = presets[scene.dataset.intensity] || presets.cinematic;
    if (reduced.matches) {
      scene.style.cssText += ';--product-o:1;--cta-o:1;--node-o:1;--signals-o:1;';
      return;
    }
    const rect = scene.getBoundingClientRect();
    const total = Math.max(rect.height - window.innerHeight, 1);
    const p = clamp((0 - rect.top) / total, 0, 1);
    const lab = ease((p - .14) / .26);
    const signals = ease((p - .34) / .22);
    const product = ease((p - .54) / .26);
    const cta = ease((p - .78) / .16);
    const final = ease((p - .82) / .14);
    scene.style.setProperty('--x', `${-p * intensity.bg}px`);
    scene.style.setProperty('--y', `${-p * intensity.fg}px`);
    scene.style.setProperty('--s', `${1.04 + p * intensity.zoom}`);
    scene.style.setProperty('--botanical-o', `${.48 + p * .22}`);
    scene.style.setProperty('--lab-o', `${.16 + lab * .46}`);
    scene.style.setProperty('--ritual-o', `${.1 + cta * .34}`);
    scene.style.setProperty('--light-x', `${-34 + p * intensity.light}%`);
    scene.style.setProperty('--light-y', `${-14 + p * 28}%`);
    scene.style.setProperty('--headline-y', `${-p * 70}px`);
    scene.style.setProperty('--headline-opacity', `${1 - ease((p - .46) / .22) * .92}`);
    scene.style.setProperty('--body-o', `${1 - ease((p - .52) / .2) * .9}`);
    scene.style.setProperty('--signals-o', signals);
    scene.style.setProperty('--signals-s', `${.84 + signals * .2}`);
    scene.style.setProperty('--node-o', signals);
    scene.style.setProperty('--node-y', `${26 - signals * 26}px`);
    scene.style.setProperty('--product-o', `${product * (1 - final * .95)}`);
    scene.style.setProperty('--product-y', `${130 - product * 130}px`);
    scene.style.setProperty('--product-s', `${.7 + product * intensity.product}`);
    scene.style.setProperty('--product-blur', `${8 - product * 8}px`);
    scene.style.setProperty('--shadow-y', `${24 + product * 28}px`);
    scene.style.setProperty('--shadow-blur', `${70 + product * 60}px`);
    scene.style.setProperty('--shadow-o', `${.1 + product * .18}`);
    scene.style.setProperty('--cta-o', cta);
    scene.style.setProperty('--cta-y', `${20 - cta * 20}px`);
    scene.style.setProperty('--final-o', final);
    scene.style.setProperty('--final-y', `${34 - final * 34}px`);
    scene.style.setProperty('--final-s', `${.94 + final * .06}`);
    setDots(scene, p);
    setSignals(scene, p);
  }
  let ticking = false;
  function update() {
    scenes.forEach(render);
    ticking = false;
  }
  function request() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }
  addEventListener('scroll', request, { passive: true });
  addEventListener('resize', request);
  reduced.addEventListener('change', request);
  request();
})();
